import apiService from '../utils/apiService';

import {
  ADD_USER,
  ADD_USER_START,
  ADD_USER_ERROR,
  UPDATE_USER,
  UPDATE_USER_START,
  UPDATE_USER_ERROR,
  GET_USER,
  GET_USER_START,
  GET_USER_ERROR,
  GET_USER_LIST,
  GET_USER_LIST_START,
  GET_USER_LIST_ERROR,
  DELETE_USER,
  DELETE_USER_START,
  DELETE_USER_ERROR,
  DEACTIVATE_USER,
  DEACTIVATE_USER_START,
  DEACTIVATE_USER_ERROR,
  ACTIVATE_USER,
  ACTIVATE_USER_START,
  ACTIVATE_USER_ERROR,
  CLEAR_ERROR_USER,
  GET_USER_LIST_PAGEABLE,
  ADD_USER_REGISTRATION,
  ADD_USER_REGISTRATION_START,
  ADD_USER_REGISTRATION_ERROR,
  UPDATE_USER_WITH_SIGNATURE_START,
  UPDATE_USER_WITH_SIGNATURE,
  UPDATE_USER_WITH_SIGNATURE_ERROR,
  GET_USER_WITH_SIGNATURE,
  GET_USER_WITH_SIGNATURE_START,
  GET_USER_WITH_SIGNATURE_ERROR,
} from './types';

import {
  userAddPath,
  userUpdatePath,
  userFindByIdPath,
  userFindAllPath,
  userDeletePath,
  userDeactivatePath,
  userActivatePath,
  userFindAllPageablePath,
  userRegistrationPath,
  userUpdateWithSignaturePath,
  userFindByIdWithSignaturePath,
} from '../constants/apiEndpoints';
import { handleServerErrorMessage, handleServerSuccessMessage, removeUnnecessaryKeys } from '../utils';
import { SignUpForm } from '../enums/SignUpEnums';
import { ModalForAddOrUpdateUser, TableMessages } from '../enums/UserEnums';

const clearError = () => {
  return {
    type: CLEAR_ERROR_USER,
  };
};

const addUserStart = () => {
  return {
    type: ADD_USER_START,
  };
};
const addUserSuccessfully = (data) => {
  return {
    type: ADD_USER,
    payload: data,
  };
};
const addUserUnsuccessfully = (err) => {
  return {
    type: ADD_USER_ERROR,
    payload: err,
  };
};

const updateUserStart = () => {
  return {
    type: UPDATE_USER_START,
  };
};
const updateUserSuccessfully = (data) => {
  return {
    type: UPDATE_USER,
    payload: data,
  };
};
const updateUserUnsuccessfully = (err) => {
  return {
    type: UPDATE_USER_ERROR,
    payload: err,
  };
};

const getUserStart = () => {
  return {
    type: GET_USER_START,
  };
};
const getUserSuccessfully = (data) => {
  return {
    type: GET_USER,
    payload: data,
  };
};
const getUserUnsuccessfully = (err) => {
  return {
    type: GET_USER_ERROR,
    payload: err,
  };
};

const getUserListStart = () => {
  return {
    type: GET_USER_LIST_START,
  };
};
const getUserListSuccessfully = (data) => {
  return {
    type: GET_USER_LIST,
    payload: data,
  };
};

const getUsersPageableListSuccessfully = (data, pageNumber, totalElements) => {
  return {
    type: GET_USER_LIST_PAGEABLE,
    payload: [data, pageNumber, totalElements],
  };
};

const getUserListUnsuccessfully = (err) => {
  return {
    type: GET_USER_LIST_ERROR,
    payload: err,
  };
};

const deleteUserStart = () => {
  return {
    type: DELETE_USER_START,
  };
};
const deleteUserSuccessfully = (id) => {
  return {
    type: DELETE_USER,
    payload: id,
  };
};
const deleteUserUnsuccessfully = (err) => {
  return {
    type: DELETE_USER_ERROR,
    payload: err,
  };
};

const deactivateUserStart = () => {
  return {
    type: DEACTIVATE_USER_START,
  };
};
const deactivateUserSuccessfully = (data) => {
  return {
    type: DEACTIVATE_USER,
    payload: data,
  };
};
const deactivateUserUnsuccessfully = (err) => {
  return {
    type: DEACTIVATE_USER_ERROR,
    payload: err,
  };
};

const activateUserStart = () => {
  return {
    type: ACTIVATE_USER_START,
  };
};
const activateUserSuccessfully = (data) => {
  return {
    type: ACTIVATE_USER,
    payload: data,
  };
};
const activateUserUnsuccessfully = (err) => {
  return {
    type: ACTIVATE_USER_ERROR,
    payload: err,
  };
};

export const deleteErrorUser = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};

const addUserRegistrationStart = () => {
  return {
    type: ADD_USER_REGISTRATION_START,
  };
};
const addUserRegistrationSuccessfully = (data) => {
  return {
    type: ADD_USER_REGISTRATION,
    payload: data,
  };
};
const addUserRegistrationUnsuccessfully = (err) => {
  return {
    type: ADD_USER_REGISTRATION_ERROR,
    payload: err,
  };
};

//WHIT SIGNATURE
const updateUserWithSignatureStart = () => {
  return {
    type: UPDATE_USER_WITH_SIGNATURE_START,
  };
};
const updateUserWithSignatureSuccessfully = (data) => {
  return {
    type: UPDATE_USER_WITH_SIGNATURE,
    payload: data,
  };
};
const updateUserWithSignatureUnsuccessfully = (err) => {
  return {
    type: UPDATE_USER_WITH_SIGNATURE_ERROR,
    payload: err,
  };
};

const getUserWithSignatureStart = () => {
  return {
    type: GET_USER_WITH_SIGNATURE_START,
  };
};
const getUserWithSignatureSuccessfully = (data) => {
  return {
    type: GET_USER_WITH_SIGNATURE,
    payload: data,
  };
};
const getUserWithSignatureUnsuccessfully = (err) => {
  return {
    type: GET_USER_WITH_SIGNATURE_ERROR,
    payload: err,
  };
};

export const createUser = (user, callback) => {
  return (dispatch) => {
    dispatch(addUserStart());
    return apiService
      .post(userAddPath(), user)
      .then((response) => {
        dispatch(addUserSuccessfully(response.data));
        handleServerSuccessMessage(
          ModalForAddOrUpdateUser.saveSuccessMessage,
          user
        );
        callback();
      })
      .catch((err) => {
        dispatch(addUserUnsuccessfully(err?.response?.data));
        handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
      });
  };
};

export const updateUser = (user, callback) => {
  return (dispatch) => {
    dispatch(updateUserStart());
    return apiService
      .post(userUpdatePath(), user)
      .then((response) => {
        dispatch(updateUserSuccessfully(response.data));
        removeUnnecessaryKeys(user);
        handleServerSuccessMessage(
          ModalForAddOrUpdateUser.updateSuccessMessage,
          user
        );
        callback();
      })
      .catch((err) => {
        dispatch(updateUserUnsuccessfully(err.response.data));
        handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
      });
  };
};

export const findUserById = (id) => {
  return (dispatch) => {
    dispatch(getUserStart());
    return apiService
      .get(userFindByIdPath(id))
      .then((response) => {
        dispatch(getUserSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getUserUnsuccessfully(err));
      });
  };
};

export const findAllUsers = () => {
  return (dispatch) => {
    dispatch(getUserListStart());
    return apiService
      .get(userFindAllPath())
      .then((response) => {
        dispatch(getUserListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getUserListUnsuccessfully(err));
      });
  };
};

export const findAllUsersPageble = (pageNumber, pageSize, filters) => {
  return (dispatch) => {
    dispatch(getUserListStart());
    return apiService
      .get(userFindAllPageablePath(pageNumber, pageSize, filters))
      .then((response) => {
        dispatch(
          getUsersPageableListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(getUserListUnsuccessfully(err));
      });
  };
};

export const deleteUser = (id) => {
  return (dispatch) => {
    dispatch(deleteUserStart());
    return apiService
      .patch(userDeletePath(id))
      .then(() => {
        dispatch(deleteUserSuccessfully(id));
      })
      .catch((err) => {
        dispatch(deleteUserUnsuccessfully(err));
      });
  };
};

export const deactivateUser = (id) => {
  return (dispatch) => {
    dispatch(deactivateUserStart());
    return apiService
      .patch(userDeactivatePath(id))
      .then((response) => {
        dispatch(deactivateUserSuccessfully(response.data));
        handleServerSuccessMessage(
          TableMessages.deactivate,
          id
        );
      })
      .catch((err) => {
        dispatch(deactivateUserUnsuccessfully(err));
      });
  };
};

export const activateUser = (id) => {
  return (dispatch) => {
    dispatch(activateUserStart());
    return apiService
      .patch(userActivatePath(id))
      .then((response) => {
        dispatch(activateUserSuccessfully(response.data));
        handleServerSuccessMessage(
          TableMessages.activate,
          id
        );
      })
      .catch((err) => {
        dispatch(activateUserUnsuccessfully(err));
      });
  };
};

export const createUserRegistration = (user, history) => {
  return (dispatch) => {
    dispatch(addUserRegistrationStart());
    return apiService
      .post(userRegistrationPath(), user)
      .then((response) => {
        dispatch(addUserRegistrationSuccessfully(response.data));        
        history.push('/login');
        handleServerSuccessMessage(
          SignUpForm.signupSuccessMessage,
          user
        );
      })
      .catch((err) => {
        dispatch(addUserRegistrationUnsuccessfully(err.response.data));
        handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
      });
  };
};
//WITH SIGNATURE
export const updateUserWithSignature = (user, callback) => {
  return (dispatch) => {
    dispatch(updateUserWithSignatureStart());
    return apiService
      .put(userUpdateWithSignaturePath(), user)
      .then((response) => {
        dispatch(updateUserWithSignatureSuccessfully(response.data));
        removeUnnecessaryKeys(user);
        handleServerSuccessMessage(
          ModalForAddOrUpdateUser.updateSuccessMessage,
          user
        );
        callback();
      })
      .catch((err) => {
        dispatch(updateUserWithSignatureUnsuccessfully(err.response.data));
        handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
      });
  };
};

export const findUserWithSignatureById = (id) => {
  return (dispatch) => {
    dispatch(getUserWithSignatureStart());
    return apiService
      .get(userFindByIdWithSignaturePath(id))
      .then((response) => {
        dispatch(getUserWithSignatureSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getUserWithSignatureUnsuccessfully(err));
      });
  };
};